import script from "./official-receipt.vue?vue&type=script&setup=true&lang=js"
export * from "./official-receipt.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__